import Swiper, {Pagination, Navigation, Autoplay} from 'swiper';

Swiper.use([Pagination, Navigation, Autoplay]);

export namespace RecipeCategoryCarousel {
	let setupSlider = () => {

		let recipeSliders = document.querySelectorAll('.js-recipe-category-carousel');

		//For Each Hero Slider Loop through and setup swiper
		recipeSliders.forEach((slider, index) => {
			slider.classList.add(`recipe-carousel--${index}`);
			const swiper = new Swiper(`.recipe-carousel--${index}`, {
				slidesPerView: 4,
				spaceBetween: 0,
				initialSlide: 0,
				
				// Navigation arrows
				navigation: {
					nextEl: `.recipe-carousel--${index} .swiper-button-next`,
					prevEl: `.recipe-carousel--${index} .swiper-button-prev`,
				},

				breakpoints: {
					0: {
						slidesPerView: 1,
						spaceBetween: 0,
						initialSlide: 0
					},
					500: {
						slidesPerView: 2,
						spaceBetween: 0,
						initialSlide: 0
					},					
					768: {
						slidesPerView: 3,
						spaceBetween: 20,
						initialSlide: 0
					},
					1024: {
						slidesPerView: 4,
						spaceBetween: 20,
						initialSlide: 0
					}
				}
			});
		});
	}

	export const init = () => {
		setupSlider();
	}
}

document.addEventListener('DOMContentLoaded', RecipeCategoryCarousel.init);
